var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "modal",
    {
      attrs: { title: "Leaderboard points breakdown", "show-footer": true },
      on: {
        close: function($event) {
          return _vm.$emit("close")
        }
      }
    },
    [
      _vm._l(_vm.breakdown, function(entry, i) {
        return _c("div", { key: i, staticClass: "breakdown-entry" }, [
          _c("div", { staticClass: "breakdown-entry__header" }, [
            _c("div", { staticClass: "breakdown-entry__meta" }, [
              _c("span", { staticClass: "breakdown-entry__label" }, [
                _vm._v("Leaderboard")
              ]),
              _c("span", { staticClass: "breakdown-entry__slug" }, [
                _vm._v(_vm._s(entry.slug))
              ])
            ]),
            entry.ranking_system
              ? _c("div", { staticClass: "breakdown-entry__meta" }, [
                  _c("span", { staticClass: "breakdown-entry__label" }, [
                    _vm._v("Scoring")
                  ]),
                  _c("span", { staticClass: "breakdown-entry__system" }, [
                    _vm._v(_vm._s(entry.ranking_system))
                  ])
                ])
              : _vm._e()
          ]),
          _c("table", { staticClass: "table breakdown-table" }, [
            _c("thead", [
              _c("tr", [
                _c("th", [_vm._v("Rule")]),
                _c("th", { staticClass: "text-right" }, [_vm._v("Points")]),
                _c("th", [_vm._v("Detail")])
              ])
            ]),
            _c(
              "tbody",
              _vm._l(entry.rules, function(rule, j) {
                return _c("tr", { key: j }, [
                  _c("td", [
                    _c("span", { staticClass: "breakdown-rule__name" }, [
                      _vm._v(_vm._s(_vm.humaniseClass(rule.class)))
                    ]),
                    _c(
                      "span",
                      {
                        staticClass: "label",
                        class: "bg-" + _vm.ruleType(rule.class)
                      },
                      [_vm._v(_vm._s(_vm.ruleType(rule.class)))]
                    )
                  ]),
                  _c(
                    "td",
                    { staticClass: "text-right breakdown-rule__points" },
                    [_vm._v(_vm._s(rule.points))]
                  ),
                  _c(
                    "td",
                    _vm._l(_vm.extraKeys(rule), function(key) {
                      return _c(
                        "span",
                        { key: key, staticClass: "breakdown-rule__meta" },
                        [
                          _c("span", { staticClass: "text-muted" }, [
                            _vm._v(_vm._s(_vm.humaniseKey(key)) + ":")
                          ]),
                          _vm._v(" " + _vm._s(rule[key]) + " ")
                        ]
                      )
                    }),
                    0
                  )
                ])
              }),
              0
            ),
            _c("tfoot", [
              _vm.roundUp(entry) > 0
                ? _c("tr", { staticClass: "breakdown-table__roundup" }, [
                    _c("td", [_vm._v("Round up")]),
                    _c("td", { staticClass: "text-right" }, [
                      _vm._v(_vm._s(_vm.roundUp(entry)))
                    ]),
                    _c("td")
                  ])
                : _vm._e(),
              _c("tr", { staticClass: "breakdown-table__total" }, [
                _c("td", [_vm._v("Total points")]),
                _c("td", { staticClass: "text-right" }, [
                  _vm._v(_vm._s(entry.score))
                ]),
                _c("td")
              ])
            ])
          ])
        ])
      }),
      _vm.breakdown.length === 0
        ? _c("p", { staticClass: "text-muted" }, [
            _vm._v("No breakdown available.")
          ])
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }